{
  "version": 1,
  "asset_id": "fdae1a5e-9854-4955-806d-1209e62cbb9d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/fdae1a5e-9854-4955-806d-1209e62cbb9d/sleeve-fitzer-1.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/fdae1a5e-9854-4955-806d-1209e62cbb9d/sleeve-fitzer-1.png",
  "original_filename": "sleeve-fitzer-1.png",
  "size": 229618,
  "content_type": "image/png",
  "created_at": "2026-07-14T23:02:47Z"
}
